import React from 'react';
import styled from 'styled-components';
import useNavigate from '@utils/useNavigate';
import Colors from './Colors';
import { Span } from './Typography';

interface Props {
  errorMessage: string | false;
  style?: React.CSSProperties | undefined;
}

export default function ErrorMessage({ errorMessage, style }: Props) {
  const { navigateWrapper } = useNavigate();
  if (!errorMessage) return null;

  function renderText() {
    if (errorMessage === 'wrongEmail') {
      return (
        <p>
          It looks like you don't have an account with us.{' '}
          <Span $mods={['link']} onClick={() => navigateWrapper('/checkout/account/')}>
            Create an account
          </Span>
        </p>
      );
    }
    if (errorMessage === 'wrongPassword') {
      return <p>Incorrect password</p>;
    }
    return <p>{errorMessage}</p>;
  }

  return <ErrorContainer style={style}>{renderText()}</ErrorContainer>;
}

const ErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 20px 30px;
  gap: 15px;
  margin-bottom: 20px;
  background: ${Colors.ecru50};
  border: 1px solid ${Colors.red};
  border-radius: 2px;

  p {
    font-family: 'BrownStd';
    font-style: normal;
    font-weight: 700;
    font-size: 14px;
    line-height: 150%;
    color: ${Colors.red};
  }
`;
